import SeoHead from "../components/common/SeoHead";
import HeroSection from "../components/home/HeroSection";
import IntroSection from "../components/home/IntroSection";
import StatsSection from "../components/home/StatsSection";
import DestinationsSection from "../components/home/DestinationsSection";
import JourneySection from "../components/home/JourneySection";
import ServicesSection from "../components/home/ServicesSection";
import WhyChooseSection from "../components/home/WhyChooseSection";
import TestimonialsPreviewSection from "../components/home/TestimonialsPreviewSection";
import FinalCtaSection from "../components/home/FinalCtaSection";

function HomePage() {
  return (
    <>
      <SeoHead
        title="NextEra Abroad | Premium Overseas Education Consultancy"
        description="Study abroad with clarity, confidence, and expert support. NextEra Abroad offers personalized counselling, strategic university shortlisting, and end-to-end admissions guidance."
        path="/"
        keywords={[
          "study abroad consultancy",
          "overseas education guidance",
          "free counselling for study abroad",
          "university shortlisting support",
          "visa guidance for students"
        ]}
      />
      <HeroSection />
      <IntroSection />
      <StatsSection />
      <DestinationsSection />
      <JourneySection />
      <ServicesSection />
      <WhyChooseSection />
      <TestimonialsPreviewSection />
      <FinalCtaSection />
    </>
  );
}

export default HomePage;
